import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-beff495c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input_postcode" }
const _hoisted_2 = { class: "input_postcode_first" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_postcode_hyphen" }, "-", -1))
const _hoisted_4 = { class: "input_postcode_second" }
const _hoisted_5 = { class: "input_postcode_button" }
const _hoisted_6 = ["disabled"]

import { ref, watchEffect } from 'vue';
import BaseTextForm from '@/components/BaseTextForm.vue';

type Emits = {
  (e: 'click', postCode: string): void;
  (e: 'update:modelValue', value: string): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'PostCodeForm',
  props: {
  modelValue: {
    type: String, // '123-4567'
    default: '',
  },
  isError: {
    type: Boolean,
    required: false,
  },
},
  emits: ["click", "update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (e: 'click', postCode: string): void;
  (e: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props


const zipCode1 = ref(props.modelValue.substring(0, 3)) || '';
const zipCode2 = ref(props.modelValue.substring(3, 7)) || '';


watchEffect(() => {
  const value = zipCode1.value + zipCode2.value;
  emit('update:modelValue', value);
});

const click = () => {
  // 連結したpostCodeを投げる
  emit('click', props.modelValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseTextForm, {
        modelValue: _unref(zipCode1),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(zipCode1) ? (zipCode1).value = $event : null)),
        maxlength: 3,
        placeholder: "123",
        isError: props.isError
      }, null, 8, ["modelValue", "isError"])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(BaseTextForm, {
        modelValue: _unref(zipCode2),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(zipCode2) ? (zipCode2).value = $event : null)),
        maxlength: 4,
        placeholder: "4567",
        isError: props.isError
      }, null, 8, ["modelValue", "isError"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        onClick: click,
        disabled: props.isError,
        class: "button_address_search"
      }, "住所検索", 8, _hoisted_6)
    ])
  ]))
}
}

})